import type { ChatHistory } from 'types/chatbot';
import type { ChatbotState } from '../index';

export const setHistory = (state: ChatbotState, { payload }: { payload: ChatHistory[] }) => {
  state.history = payload;
};
